export var EventItem;
(function (EventItem) {
    EventItem[EventItem["StartTime"] = 0] = "StartTime";
    EventItem[EventItem["IsLive"] = 1] = "IsLive";
    EventItem[EventItem["HomeTeamName"] = 2] = "HomeTeamName";
    EventItem[EventItem["AwayTeamName"] = 3] = "AwayTeamName";
    EventItem[EventItem["Score"] = 4] = "Score";
    EventItem[EventItem["Market"] = 7] = "Market";
    EventItem[EventItem["EventId"] = 8] = "EventId";
    EventItem[EventItem["HomeTeamLogoUrl"] = 19] = "HomeTeamLogoUrl";
    EventItem[EventItem["AwayTeamLogoUrl"] = 20] = "AwayTeamLogoUrl";
    EventItem[EventItem["TotalBettingAndTotalUserTeam"] = 24] = "TotalBettingAndTotalUserTeam";
    EventItem[EventItem["TeamWinning"] = 25] = "TeamWinning";
    EventItem[EventItem["EndTime"] = 28] = "EndTime";
    EventItem[EventItem["Md5Code"] = 29] = "Md5Code";
    EventItem[EventItem["ResultCode"] = 30] = "ResultCode";
    EventItem[EventItem["PlayerBettingStatistics"] = 31] = "PlayerBettingStatistics";
})(EventItem || (EventItem = {}));
export var Market;
(function (Market) {
    Market[Market["DrawNotBet"] = 16] = "DrawNotBet";
})(Market || (Market = {}));
export var LeagueEvent;
(function (LeagueEvent) {
    LeagueEvent[LeagueEvent["LeagueId"] = 0] = "LeagueId";
    LeagueEvent[LeagueEvent["EventList"] = 2] = "EventList";
})(LeagueEvent || (LeagueEvent = {}));
export var TotalBettingAndTotalUserTeamField;
(function (TotalBettingAndTotalUserTeamField) {
    TotalBettingAndTotalUserTeamField[TotalBettingAndTotalUserTeamField["HomeTotalBetting"] = 0] = "HomeTotalBetting";
    TotalBettingAndTotalUserTeamField[TotalBettingAndTotalUserTeamField["AwayTotalBetting"] = 1] = "AwayTotalBetting";
    TotalBettingAndTotalUserTeamField[TotalBettingAndTotalUserTeamField["HomeTotalUser"] = 2] = "HomeTotalUser";
    TotalBettingAndTotalUserTeamField[TotalBettingAndTotalUserTeamField["AwayTotalUser"] = 3] = "AwayTotalUser";
})(TotalBettingAndTotalUserTeamField || (TotalBettingAndTotalUserTeamField = {}));
export var TeamWinningValue;
(function (TeamWinningValue) {
    TeamWinningValue[TeamWinningValue["Home"] = 1] = "Home";
    TeamWinningValue[TeamWinningValue["Away"] = 2] = "Away";
})(TeamWinningValue || (TeamWinningValue = {}));
export var ODD_EVEN;
(function (ODD_EVEN) {
    ODD_EVEN[ODD_EVEN["ODD_ODD"] = 0] = "ODD_ODD";
    ODD_EVEN[ODD_EVEN["ODD_EVEN"] = 1] = "ODD_EVEN";
    ODD_EVEN[ODD_EVEN["OFFER_ID"] = 2] = "OFFER_ID";
    ODD_EVEN[ODD_EVEN["IS_SUSPENDED_ODDS"] = 3] = "IS_SUSPENDED_ODDS";
    ODD_EVEN[ODD_EVEN["GROUP_ID"] = 4] = "GROUP_ID";
    ODD_EVEN[ODD_EVEN["IS_PROMOTION"] = 5] = "IS_PROMOTION";
    ODD_EVEN[ODD_EVEN["IS_PARLAY_ODD"] = 6] = "IS_PARLAY_ODD";
    ODD_EVEN[ODD_EVEN["IS_CASHOUT"] = 7] = "IS_CASHOUT";
})(ODD_EVEN || (ODD_EVEN = {}));
